import { ReactNode } from 'react';
import cx from 'classnames';
import { Text } from '@intellecteu/common-ui';

import s from './styles.module.scss';

interface IInfoCardItemProps {
  title?: string;
  value?: string | number | ReactNode;
  children?: ReactNode;
  className?: string;
  // need for correct render in different places;
  titleMaxWidth?: string;
  flexAlign?: string;
  valueClassName?: string;
}

export function InfoCardItem({
  title,
  value,
  children,
  className,
  titleMaxWidth = '40%',
  flexAlign = 'align-items',
  valueClassName,
}: IInfoCardItemProps) {
  return value ? (
    <div className={cx(s.infoItem, className)} style={{ alignItems: flexAlign }}>
      {title ? (
        <Text color="secondaryBlue" className={s.infoItemTitle} style={{ maxWidth: titleMaxWidth }}>
          {title}:
        </Text>
      ) : null}
      {typeof value === 'object' ? (
        value
      ) : (
        <Text size={Text.size.l} className={cx(valueClassName, s.infoItemValue)}>
          {value}
        </Text>
      )}
      {children}
    </div>
  ) : null;
}

export default InfoCardItem;
